import format from 'date-fns/format';
import get from 'lodash/get';
import FoodUtils from './utils/food-utils';
import css from './FoodlogCard.scss';

const FoodlogMealCard = ({meals}) => {
    const FoodlogMealCardContent = () => {
        return (
            <>
                {meals.map((meal, index) => {
                    const foodItemList = meal.foodItemsList;
                    const foodPortion = foodItemList?.getIngredientsList?.()[0];
                    const createTime = meal.createTime;
                    const nixFood = meal.nixFood;

                    return (
                        <div key={index}>
                            <div>
                                {foodItemList && (
                                    <p className={css['food-log-text']}>
                                        <b>{foodItemList?.getItemName()}</b>
                                        &nbsp;
                                        {foodPortion
                                            .getPortionQuantity?.()
                                            ?.getValue?.()}
                                        &nbsp;
                                        {foodPortion
                                            .getPortionUnit?.()
                                            ?.getValue?.()}
                                        &nbsp;
                                        {get(createTime, 'timeStampNoTimeZone')
                                            ? format(
                                                  createTime?.timeStampNoTimeZone,
                                                  'hh:mm aaa'
                                              )
                                            : ''}
                                    </p>
                                )}
                                {nixFood &&
                                    nixFood.array &&
                                    nixFood.array.length > 0 && (
                                        <span>
                                            {nixFood.array[1]},{' '}
                                            {nixFood.array[3].length === 0 ? (
                                                <span> 0 </span>
                                            ) : (
                                                <span>
                                                    {FoodUtils.formatQuantity(
                                                        nixFood
                                                            .getPortionQuantity?.()
                                                            ?.getValue?.()
                                                    )}
                                                </span>
                                            )}{' '}
                                            {nixFood.array[4]}
                                        </span>
                                    )}
                                {nixFood &&
                                    nixFood.array &&
                                    nixFood.array.length > 0 &&
                                    meal.note &&
                                    meal.note.length > 0 &&
                                    meal.note.length > 0 && <span>, </span>}
                                {meal.note && meal.note.length > 0 && (
                                    <span className={css['food-note']}>
                                        {meal.note}
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };

    return FoodlogMealCardContent();
};

export default FoodlogMealCard;
